import { z } from "zod/v4"
import { SelectionParticipantIdSchema, SelectionSequenceId, SelectionSequenceIdSchema } from "../id"
import { DocumentSnapshotLike } from "../firestore"
import { CreatedAt, UpdatedAt } from "./system"

export const SelectionSequenceKindParticipate = z.literal("participate")
export const SelectionSequenceKindPseudoNominate = z.literal("pseudo-nominate")
export const SelectionSequenceKindNominate = z.literal("nominate")
export const SelectionSequenceKindUpdateSelectedParticipant = z.literal("update-selected-participant")
export const SelectionSequenceKindRemoveNominatedParticipant = z.literal("remove-nominated-participant")

export const SelectionSequenceKind = z.union([
  SelectionSequenceKindParticipate,
  SelectionSequenceKindPseudoNominate,
  SelectionSequenceKindNominate,
  SelectionSequenceKindUpdateSelectedParticipant,
  SelectionSequenceKindRemoveNominatedParticipant,
])

// TODO value
export const SelectionPseudoNominateKindType1 = z.literal("type1")
export const SelectionPseudoNominateKindType2 = z.literal("type2")

export const SelectionPseudoNominateKind = z.union([
  SelectionPseudoNominateKindType1,
  SelectionPseudoNominateKindType2,
])

export type SelectionSequenceKind = z.infer<typeof SelectionSequenceKind>

export const SelectionSequenceDocumentMeta = z.union([
  z.object({
    kind: SelectionSequenceKindParticipate,
    value: z.object({
      open: z.boolean(),
    })
  }),
  z.object({
    kind: SelectionSequenceKindPseudoNominate,
    value: z.object({
      kind: SelectionPseudoNominateKind,
      participant_ids: z.array(SelectionParticipantIdSchema),
    }),
  }),
  z.object({
    kind: SelectionSequenceKindNominate,
    value: z.object({
      participant_ids: z.array(SelectionParticipantIdSchema),
    }),
  }),
  z.object({
    kind: SelectionSequenceKindUpdateSelectedParticipant,
    value: z.object({
      selected: z.boolean(),
      participant_id: SelectionParticipantIdSchema,
    })
  }),
  z.object({
    kind: SelectionSequenceKindRemoveNominatedParticipant,
    value: z.object({
      participant_id: SelectionParticipantIdSchema,
    })
  }),
])

export type SelectionSequenceDocumentMeta = z.infer<typeof SelectionSequenceDocumentMeta>

export const SelectionSequenceDocumentBody = z.intersection(
  SelectionSequenceDocumentMeta,
  z.object({
    created_at: CreatedAt,
    updated_at: UpdatedAt,
  })
)

export type SelectionSequenceDocumentBody = z.infer<typeof SelectionSequenceDocumentBody>

export const SelectionSequenceDocument = z.intersection(
  SelectionSequenceDocumentBody,
  z.object({
    id: SelectionSequenceIdSchema,
  })
)

export type SelectionSequenceDocument = z.infer<typeof SelectionSequenceDocument>

export class SelectionSequenceDocuments {

  static toDocumentData(entity: SelectionSequenceDocument): object {
    return {
      ...entity,
      // id は document path に入るので入れない
      id: undefined,
    }
  }

  static fromDocumentSnapshot(doc: DocumentSnapshotLike | null): SelectionSequenceDocument | null {
    if (!doc) {
      return null
    }
    const data = doc.data()
    if (data === undefined) {
      return null
    }

    return {
      id: SelectionSequenceId(doc.id),
      kind: data["kind"],
      value: data["value"],
      created_at: data["created_at"],
      updated_at: data["updated_at"],
    }
  }
}
